import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-member-card',
  name: '会员卡片',
  icon: '会',
  group: '智慧景区',
  description: '展示会员等级、积分和登录引导，可导航至会员中心。',
  defaultProps: {
    title: '会员中心',
    subtitle: '登录享更多会员权益',
    loginButtonText: '登录 / 注册'
  }
}
